// @flow

import React, { useEffect } from 'react'
import withPage from 'server/withPage'
import { graphql } from 'react-apollo'
import { bindActionCreators } from 'redux'
import { setUIState } from 'redux/modules/ui'
import { actions as hostSimulationActions } from 'redux/modules/hostSimulation'
import { actions as accountActions } from 'redux/modules/account'
import { authUrlWithQuery } from 'helpers/format'
import Redirect from 'components/atoms/Redirect'
import Path from 'routes/path'
import { checkTokenExpired } from 'helpers/auth'
import { amplitudeLogEvent } from 'helpers/amplitude'
import HostSignUpPage from 'components/pages/HostSignUpPage'
import AccountTemplate from 'components/templates/AccountTemplate'
import { HOST_ENTRY_QUERY } from './graphql'
import {
  setInputUserInformation,
  submitGuestAndHost,
  submitHost,
} from './utils'

const HostSignUpPageContainer = ({
  actions,
  account,
  config,
  restClient,
  data,
  ui,
}) => {
  useEffect(() => {
    actions.setUIState({
      canSubmit: true,
    })
    amplitudeLogEvent('Start Host Signup')
  }, [])

  const onChange = e => {
    e.preventDefault()
    setInputUserInformation(e, account, actions)
  }
  const onSubmitGuestAndHost = e => {
    e.preventDefault()
    submitGuestAndHost(account, config, restClient, actions)
    amplitudeLogEvent('Select Host Signup', { "Type": "Email" })
  }
  const onSubmitHost = e => {
    e.preventDefault()
    submitHost(account, config, data, restClient, actions)
    amplitudeLogEvent('Select Host Signup', { "Type": "Email" })
  }

  // 既にホストアカウントを持っている場合は、ダッシュボードにリダイレクトさせる
  if (data.viewer?.owners?.results[0]?.username) {
    const owner = {}
    owner.username = data.viewer?.owners?.results[0]?.username
    return <Redirect to={Path.dashboard(owner, '/rooms')} />
  }

  const ownerName = account.ownername
  if (account.isSuccess && ownerName) {
    if (ui.isSubmitFromForm) {
      return <Redirect to={'/sign_up/sent'} />
    } else {
      let owner = {}
      owner.username = ownerName
      return <Redirect to={Path.dashboard(owner, '/rooms')} />
    }
  }

  return (
    <AccountTemplate
      title={i18n.t('server.account.host_signup.title')}
      description={i18n.t('server.account.host_signup.description')}
      url={config.URL}
      config={config}
    >
      <HostSignUpPage
        onSubmitGuestAndHost={onSubmitGuestAndHost}
        onSubmitHost={onSubmitHost}
        onChange={onChange}
        account={account}
        config={config}
        actions={actions}
        viewer={data?.viewer}
        canSubmit={ui.canSubmit}
      />
    </AccountTemplate>
  )
}

function mapStateToProps(state: Object) {
  return state
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = {
    setAccount: accountActions.setAccount,
    setUIState,
    hostSignUp: accountActions.hostSignUp,
    ...hostSimulationActions,
  }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

const withData = graphql(HOST_ENTRY_QUERY, {
  skip: checkTokenExpired(),
})
export default withPage(
  HostSignUpPageContainer,
  mapStateToProps,
  mapDispatchToProps,
  {
    graphql: withData,
  },
)
